import Cookies from 'js-cookie'
import { doAppGraphqlRequest } from 'ducks/requests/operations'
import { selectQueryParams } from 'selectors/location'
import { createAffiliateClickMutation } from './queries'
import { getClickIdFromStorage, setClickIdInStorage } from './util'
import { CREATE_AFFILIATE_CLICK } from './types'

export const doCreateAffiliateClick = () => async (dispatch, getState) => {
  const state = getState()
  const { ref: queryParamsRef } = selectQueryParams(state)
  const cookieRef = Cookies.get('affiliateMarketingSiteRef')

  const ref = queryParamsRef || cookieRef

  if (!ref || !ref.length) {
    return null
  }

  const clickIdFromStorage = getClickIdFromStorage()

  if (clickIdFromStorage) {
    return null
  }

  const response = await dispatch(
    doAppGraphqlRequest(CREATE_AFFILIATE_CLICK, createAffiliateClickMutation, {
      referralCode: ref,
    })
  )
  const { affiliatesClickCreate: { clickId } = {} } = response || {}

  if (clickId) {
    setClickIdInStorage(clickId)
  }

  return response
}
